import { Link } from "react-router-dom";
import BotonInstructivo from "../../ComponentesGlobales/BotonInstructivo";
import "./produccion.css";

export default function Produccion() {
  return (
    <main className="produccion-centro">
      <header>
        <span className="produccion-centro-icono"><i className="pi pi-box" aria-hidden="true" /></span>
        <div><small>Operación</small><h1>Producción</h1><p>Elegí el movimiento que necesitás registrar.</p></div>
        <BotonInstructivo to="/tutorial/produccion" className="produccion-instructivo" />
      </header>
      <section className="produccion-centro-opciones" aria-label="Movimientos de producción">
        <Link to="/produccion-entradas">
          <i className="pi pi-arrow-circle-down" aria-hidden="true" />
          <span><strong>Entradas de producción</strong><small>Cargá materias primas e insumos al proceso.</small></span>
          <i className="pi pi-chevron-right" aria-hidden="true" />
        </Link>
        <Link to="/produccion-salidas">
          <i className="pi pi-arrow-circle-up" aria-hidden="true" />
          <span><strong>Salidas de producción</strong><small>Registrá productos terminados y salidas.</small></span>
          <i className="pi pi-chevron-right" aria-hidden="true" />
        </Link>
      </section>
    </main>
  );
}
